import { FC } from "react";
import { Button } from "../../Buttons/Button/Button";
import { Modal } from "../../Modal/Modal";
import { ScoreBar } from "./ScoreBar";
import styles from "./PenaltyInfo.module.scss";
import { useSelector } from "../../../hooks";
import { formatTimePeriod } from "../../../utils/time";
import { CurrencySmallIcon } from "../../CurrencySmallIcon/CurrencySmallIcon";

interface IPenaltyInfoProps {
    taskReward: number;
    onClose: () => void;
}

export const PenaltyInfo: FC<IPenaltyInfoProps> = ({ taskReward, onClose }) => {
    const penalties = useSelector(store => store.tasks.joinChannelTasks?.penalty?.penalties);
    const handler = () => onClose();

    const closeButton = () => <Button caption='Закрыть' type='orange' handler={ handler } />

    if (!penalties) {
        onClose();
        return <></>;
    }

    const getContent = () => {
        return (
            <div className={ styles.container }>
                <ScoreBar />

                <p className={ styles.text }>
                    <span><b>Мы обнаружили, что вы часто отписываетесь от каналов.</b></span>
                    <span>Это приводит к временным ограничениям.</span>

                    <div className={ styles.list }>
                        { penalties.reward > 0 && 
                            <div>
                                <span>- Награда уменьшена до </span>
                                <CurrencySmallIcon value={ Math.round(taskReward * (1 - penalties.reward)) } />
                            </div>
                        }
                        <span>{`- Время проверки увеличено до ${formatTimePeriod(penalties.pendingTime)}`}</span>
                        { penalties.tasksAmount > 0 && <span>{`- Количество доступных заданий в сутки уменьшено на ${penalties.tasksAmount}`}</span> }                        
                    </div>

                    <div>
                        <b>Как убрать ограничения?</b>
                    </div>

                    <div>
                        Не отписывайтесь от действующих заданий и через некоторое время проверка снова станет мгновенной, а количество заданий и награды максимальными.
                    </div>
                </p>
            </div>
        );
    }
    
    return (
        <Modal
            name='PenaltyInfo'
            title='Низкое качество подписок'
            message={ getContent() }
            button={ closeButton() }
        />
    );
}